import {
    Component,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    OnChanges,
    HostBinding,
    Input,
    Output,
    EventEmitter,
    SimpleChanges
} from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
    selector: 'p-slide-toggle',
    template: `
        <mat-slide-toggle class="p-slide-toggle" [checked]="currentToggle" [disabled]="disabled" (change)="change($event)">
            <ng-container *ngIf="isShowLabel()">
                {{ currentToggle ? labelOn : labelOff }}
            </ng-container>
        </mat-slide-toggle>
    `,
    styleUrls: ['./p-slide-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class PSlideToggleComponent implements OnChanges {
    currentToggle = false;

    @HostBinding('class.p-slide-toggle-namespace') pSlideToggleNamespace = true;

    @Input() labelOn?: string;
    @Input() labelOff?: string;

    @Input() checked: boolean | undefined = false;
    @Input() disabled = false;
    @Output() toggleChanged = new EventEmitter<boolean>();

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['checked'] !== undefined) {
            // Convert any value to proper boolean: 0/false/null/undefined = false, everything else = true
            this.currentToggle = !!changes['checked'].currentValue;
        }
    }

    isShowLabel() {
        return (this.checked && this.labelOn) || (!this.checked && this.labelOff);
    }

    change(value: MatSlideToggleChange) {
        this.currentToggle = value.checked;
        this.toggleChanged.emit(this.currentToggle);
    }
}
